import { useDebugValue, useState } from 'react';
import notification from 'app/config/notification';
import lineEndpoint from '../../../api/services/lineEndpoint';
import requestEndpoints from 'app/api/services/requestEndpoints';

export const useSearchProcess = (config = {throwError: true, lockRequest: true}) => {
  useDebugValue('Use Search Process');
  const [fetchingProcess, setFetchingProcess] = useState(false);

  const [cdProcesso, setCdProcesso] = useState('');
  const [nuProcesso, setNuProcesso] = useState('');

  const [cdSolicitacao, setCdSolicitacao] = useState('');
  const [nuSolicitacao, setNuSolicitacao] = useState('');

  const [processo, setProcesso] = useState(null);
  const [solicitacao, setSolicitacao] = useState(null);


  const [blockRequest, setBlockRequest] = useState(false);
  const [blockProcess, setBlockProcess] = useState(false);

  const searchByProcess = async processNumber => {
    notification("Realizando busca de processo", { autoClose: 2000, type: 'info' });
    if (!processNumber) {
      setNuProcesso('');
      setCdProcesso('');
      setNuSolicitacao('');
      setCdSolicitacao('');
      return setBlockRequest(false);
    }
    try {
      setFetchingProcess(true);
      setBlockRequest(true);
      setBlockProcess(true);
      const response = await lineEndpoint.getProcess({ numero: processNumber });
      const process = response.data;
      if (!process || !process.id || !process.id.trim()) {
        setProcesso(null);
        setCdProcesso('');
        setSolicitacao(null);
        setCdSolicitacao('')
        setNuSolicitacao('');
        setBlockRequest(false);
        if(config && config.throwError) throw Error('O número do processo não existe no CPA');
      } else {
        await searchRequestByCdProcesso(process.id);
        setProcesso(process);
        setNuProcesso(process.numero);
        setCdProcesso(process.id);
      }
    } catch (error) {
      notification(error.message, { toastId: 'PROCESS_NOT_CPA', type: 'error' });
    } finally {
      setFetchingProcess(false);
      setBlockProcess(false);
    }
  };

  const searchByRequest = async (requestNumber, params) => {
    if (!requestNumber) return;
    try {
      setFetchingProcess(true);
      setBlockProcess(true);
      setBlockRequest(true);
      setProcesso(null);
      setCdProcesso('')
      setNuProcesso('');
      const response = await requestEndpoints.getRequests(
        { txtBusca: requestNumber, page: 0, size: 1 },
        ''
      );
      if (!response || response.data.content.length === 0) {
        setSolicitacao(null);
        setCdSolicitacao('')
        setNuSolicitacao('');
        setBlockRequest(false);
        throw new Error('Solicitação não encontrada');
      }
      if (!!params && !!params.deCpfCnpj) {
        const parsedRequest = parseRequest(response.data.content[0].jsonSolicitacao);
        if (parsedRequest.deCpfCnpj !== params.deCpfCnpj) {
          setSolicitacao(null);
          setCdSolicitacao('')
          setNuSolicitacao('');
          setBlockRequest(false);
          throw new Error('A solicitação não pertence à esta empresa');
        }
      }
      const foundRequest = response.data.content[0];
      setSolicitacao(foundRequest);
      setNuSolicitacao(foundRequest.nuSolicitacaoFmt);
      setCdSolicitacao(foundRequest.cdSolicitacao)
      setNuProcesso(foundRequest.nuProcesso);
      setCdProcesso(foundRequest.cdProcesso);
      if(!config.lockRequest) setBlockRequest(false)
      return foundRequest;
    } catch (error) {
      notification(error.message, { toastId: 'REQUEST_NOT_FOUND', type: 'error' });
    } finally {
      setBlockProcess(false);
      setFetchingProcess(false);
    }
  };

  const searchRequestByCdProcesso = async processId => {
    try {
      setFetchingProcess(true);
      setBlockRequest(true);
      const response = await lineEndpoint.getRequestByProcessId({ id: processId });
      if (response && response.status === 200) {
        if (Object.keys(response.data).length === 0) {
          setSolicitacao(null);
          setCdSolicitacao('')
          setNuSolicitacao('');
        } else {
          setBlockProcess(false);
          setSolicitacao(response.data);
          setCdSolicitacao(response.data.cdSolicitacao)
          setNuSolicitacao(response.data.nuSolicitacaoFmt);
        }
      }
    } catch (error) {
      notification('Não existe solicitação para este processo', {
        toastId: 'PROCESS_REQUEST_NOT_FOUND',
        type: 'warn',
      });
    } finally {
      setFetchingProcess(false);
    }
  };

  const parseRequest = jsonRequest => {
    if (jsonRequest) {
      return JSON.parse(jsonRequest);
    }
  };

  return {
    searchByProcess,
    searchByRequest,
    setCdProcesso,
    setNuProcesso,
    setCdSolicitacao,
    setNuSolicitacao,
    setBlockProcess,
    setBlockRequest,
    cdProcesso,
    cdSolicitacao,
    nuProcesso,
    nuSolicitacao,
    blockProcess,
    blockRequest,
    fetchingProcess,
    processo,
    solicitacao,
  };
};
